exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".region[data-v-1c5f6c2d] {\n  background-color: white;\n}\n.total-first-row[data-v-1c5f6c2d] {\n  text-align: right;\n  font-weight: bold;\n}\ntd[data-v-1c5f6c2d] {\n  border: 1px solid black;\n}\n.result[data-v-1c5f6c2d] {\n  text-align: center;\n  font-size: larger;\n}\n.divider[data-v-1c5f6c2d] {\n  visibility: hidden;\n  border: none;\n}\n.bold[data-v-1c5f6c2d] {\n  font-weight: bold;\n}\n.region[data-v-1c5f6c2d] {\n  font-size: larger;\n}\n.no-region[data-v-1c5f6c2d] {\n  font-size: larger;\n  font-weight: bold;\n  color: red;\n}\n", ""]);

// exports
